// Below state is added for workspace metadata KLM-8948

import { dispatch } from "@rematch/core";
import { workspaceMetadataService } from "../../services/feathers.service";

const initialState = {
  wspaceMetadata: {},
  newWspaceMetadata: {},
};

export default {
  state: initialState,
  reducers: {
    setWspaceMetadata(state, payload) {
      return {
        ...state,
        wspaceMetadata: payload,
      };
    },
    setNewWspaceMetadata(state, payload) {
      return {
        ...state,
        newWspaceMetadata: payload,
      };
    },
  },
  effects: {
    async addMetaData(payload, state) {
      try {
        payload.accountId = state.app.selectedAccount._id;
        payload.organizationId = state.app.selectedOrganisation.id;
        payload.type = "metaData";
        await workspaceMetadataService.create(payload);
      } catch (error) {
        console.log("Error in adding Metadata", error);
        throw error;
      }
    },
    async getMetaData(payload, state) {
      try {
        let query = {
          organizationId: state.app.selectedOrganisation.id,
          accountId: state.app.selectedAccount._id,
        };
        let wsmetaData = await workspaceMetadataService.find({ query: query });
        if (wsmetaData.data.length !== 0) {
          await dispatch.workspaceMetaData.setWspaceMetadata(
            wsmetaData.data[0]
          );
        }
      } catch (error) {
        console.log("Error in getting Metadata", error);
        throw error;
      }
    },
    async updateMetaData(payload, state) {
      try {
        await workspaceMetadataService.patch(payload._id, {
          $set: { metaData: payload.metaData },
        });
      } catch (error) {
        console.log("Error in updating Metadata", error);
        throw error;
      }
    },
  },
};
